import React from 'react'
import { Button } from '@mui/material'
import './button.css'

const CustomButton = ({text, icon ,onPress}) => {
  return (
    <Button className="btn" endIcon={icon ? (<div className="btn-icon">{icon}</div>):null} onClick={() => onPress()}>
        <span className='btn-text'>{text}</span>
    </Button>
  )
}

export default CustomButton